import { render, staticRenderFns } from "./WhDateBox.vue?vue&type=template&id=5fc8f99b&scoped=true"
import script from "./WhDateBox.vue?vue&type=script&lang=js"
export * from "./WhDateBox.vue?vue&type=script&lang=js"
import style0 from "./WhDateBox.vue?vue&type=style&index=0&id=5fc8f99b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc8f99b",
  null
  
)

export default component.exports